import { useContext } from 'react'
import { SelectedFeederContext } from '../components/feeder/selectedFeederContext.ts'

/** Access the shared cross-view selected-feeder state. */
export function useSelectedFeeder() {
  return useContext(SelectedFeederContext)
}
